import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "@blueskydataplatform/shared-ui/global.css";
import App from "./App.tsx";
import { AppProvider } from "./provider.tsx";

createRoot(document.getElementById("vnx-app")!).render(
  <StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </StrictMode>
);
